<template>
  <div class="shop-create-map main">
    <!-- <p class="has-text-danger" v-show="error">{{ errorMsg }}</p> -->
    <div class="field">
      <p class="control has-icons-left has-icons-right">
        <input
          style="display: none"
          type="address"
          name="fakeusernameremembered"
        />
        <input
          ref="autocomplete"
          class="input is-medium"
          type="text"
          v-model="locationInput"
          :placeholder="$t('enter-location')"
          onfocus="value = ''"
          v-on:keyup="checkLength"
          autocomplete="hide-address-autofill"
        />
        <span class="icon is-small is-left">
          <i class="fa fa-globe-asia" />
        </span>
        <span
          class="icon is-small is-right"
          style="pointer-events: initial"
          @click="enterCoords"
        >
          <i class="fa fa-map-marker-alt" />
        </span>
      </p>
    </div>

    <div class="map-wrapper">
      <div :id="mapID" class="map">
        <div v-if="userCoords" class="leaflet-top leaflet-right">
          <div class="button is-rounded recenter-btn" @click="recenter">
            <i
              class="fa fa-crosshairs has-text-grey"
              :class="{ 'fa-spin': spin }"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="confirm-wrapper">
      <a
        class="button is-success is-medium is-fullwidth"
        @click="confirmLocation"
      >
        {{ $t("confirm-address") }}
      </a>
    </div>
  </div>
</template>

<script>
import $Scriptjs from "scriptjs";
import L from "leaflet";
import "leaflet.locatecontrol";
import "leaflet.awesome-markers";
import geo from "@/geo";

export default {
  name: "ShopCreateMap",
  props: {
    country: String,
    city: String,
  },
  data() {
    return {
      mapID: "shop-create-map-map",
      map: undefined,
      marker: undefined,
      blueDot: null, // previously called userMarker
      error: false,
      errorMsg: "Select an address from list or drag the map to set the pin",
      locationInput: "",
      autocomplete: undefined,
      place: undefined, // google place result
      addressName: "",
      fullAddress: "",
      streetName: "",
      googleStreetName: "",
      delay: true,
      spin: false,
    };
  },
  computed: {
    // fallbackCountry() {
    //   if (!this.$store.state.selectedBusiness) return "th"; // default thailand
    //   return this.$store.state.selectedBusiness.country; // otherwise country of last business selected
    // },
    userCoords() {
      // return this.$store.getters.getUserLatLon; // getters.getUserLocation
      return this.$store.getters.getUserLocationWithFallback;
    },
  },
  created() {
    L.AwesomeMarkers.Icon.prototype.options.prefix = "fa";
  },
  mounted() {
    var url = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBYOwhqakcxLQQLpljhkug2WsNSA02cqss&libraries=places`;
    $Scriptjs(url, () => this.initGoogle());
    this.initMap();
    this.delay = false;
  },
  methods: {
    checkLength() {
      if (this.locationInput && this.locationInput.length > 15)
        this.error = true;
      else this.error = false;
    },
    enterCoords() {
      this.infoToast("TODO: enterCoords");
    },
    // updateAutocomplete() {
    //   var opt = { componentRestrictions: { country: this.country } }; // "sg", "th"
    //   if (this.autocomplete) this.autocomplete.setOptions(opt);
    // },
    initGoogle() {
      this.autocomplete = new google.maps.places.Autocomplete(
        this.$refs.autocomplete,
        {
          types: [], // uses all, options are ["address", "establishment", "geocode"]
          componentRestrictions: { country: this.country }, // shouldn't be hard-coded after international expansion
        }
      );
      // this.geolocate(); // will bias google places to current location
      this.geolocateCity(); // will bias google places to given city

      this.autocomplete.addListener("place_changed", () => {
        this.error = false;
        var place = this.autocomplete.getPlace();
        this.addressName = place.name;
        this.fullAddress = place.formatted_address;
        this.url = place.url;
        this.place = place;
        if (place.address_components) {
          if (place.address_components[0]) {
            this.googleStreetName = place.name; // place.address_components[0].long_name;
          }
        }

        this.locationInput = place.name; //place.types.join(", ");
        this.console(`The user picked ${name}`, place);
        var lat = place.geometry.location.lat();
        var lng = place.geometry.location.lng();
        this.updateMarkerLocation([lat, lng]);
      });
    },
    // Bias autocomplete to the user geolocation,
    geolocate() {
      // if you have a location use that first
      var fallbackCoords = this.$store.getters.getUserLocationWithFallback;
      if (fallbackCoords) {
        this.biasAutocomplete(fallbackCoords[0], fallbackCoords[1]); // [lat, lon]
      }
      // then try to get updated location
      if (!navigator.geolocation) return; // FB in-app browser doesn't allow GPS
      navigator.geolocation.getCurrentPosition((position) => {
        var p = position.coords;
        this.biasAutocomplete(p.latitude, p.longitude);
      });
    },
    geolocateCity() {
      var coords = geo.geos().find((g) => g.name === this.city);
      console.log("geolocateCity", this.city, coords);
      if (!coords) {
        this.errorToast(`City [ ${this.city} ] not found in geo package`);
        return; // invalid city
      }
      this.biasAutocomplete(coords.lat, coords.lon);
    },
    biasAutocomplete(lat, lon) {
      var circle = new google.maps.Circle({
        center: { lat: lat, lng: lon },
        radius: 25000, // I suspect this is null often, so better to hardcode to 25,000 m
      });
      this.autocomplete.setBounds(circle.getBounds());
      // this.autocomplete.setOptions({ strictBounds: true });
    },
    updateMarkerLocation(coords) {
      if (!this.marker || !coords) return;
      this.marker.setLatLng(coords);
      this.map.setView(coords, 17);
    },
    initMap() {
      var tilesURL = this.$t("geo.map-tiles"); // language specific maps
      var initialLocation = this.$store.getters.getUserLocationWithFallback;
      if (!initialLocation) initialLocation = [13.73114, 100.57529]; // Bangkok Soi 41
      console.log("initialLocation", initialLocation);

      this.map = L.map(this.mapID, { attributionControl: false });
      this.map.setView(initialLocation, 17);
      L.tileLayer(tilesURL, {
        tileSize: 512,
        zoomOffset: -1,
        minZoom: 4,
        maxZoom: 19,
      }).addTo(this.map);

      var icon = L.AwesomeMarkers.icon({
        icon: "street-view",
        markerColor: "blue",
      });
      var iconDrag = L.AwesomeMarkers.icon({
        icon: "crosshairs",
        markerColor: "blue",
        spin: true,
      });

      this.marker = L.marker(initialLocation, { icon: icon }).addTo(this.map);
      this.marker.normalIcon = icon;
      this.marker.dragIcon = iconDrag;

      var popupOpts = { closeButton: false, autoPan: true };
      this.marker.bindPopup("<i>Confirm address?</i>", popupOpts);

      this.map.on("move", () => {
        if (!this.map || !this.marker || this.delay) return;
        this.marker.setLatLng(this.map.getCenter());
      });
      this.map.on("dragstart", () => {
        this.marker.setIcon(this.marker.dragIcon);
      });
      this.map.on("moveend", () => {
        if (!this.map || !this.marker) return;
        this.marker.setLatLng(this.map.getCenter()); // needed?
        this.marker.center = this.map.getCenter();
        this.marker.setIcon(this.marker.normalIcon);
      });

      if (this.userCoords) this.drawUserLocation(); // user is blueDot
    },
    drawUserLocation() {
      var coords = this.userCoords; // this.$store.getters.getUserLatLon;
      if (!coords) coords = [13.73114, 100.57529]; // Bangkok Soi 41
      var icon = L.divIcon({
        html: `<div class="blue-dot pulse"></div>`,
        popupAnchor: [1, -6],
        className: "none",
      });
      this.blueDot = L.marker(coords, { icon: icon });
      this.blueDot.addTo(this.map);
      var popupOpts = { closeButton: false, autoPan: true };
      this.blueDot.bindPopup(this.$t("ride.your-current-gps"), popupOpts);
    },
    recenter() {
      this.updateUserMarkerLocation(true);
      this.spin = true;
      setTimeout(() => (this.spin = false), 600);
    },
    updateUserMarkerLocation(flyTo) {
      if (!this.userCoords) return;
      this.blueDot.setLatLng(this.userCoords);
      if (flyTo) this.map.flyTo(this.userCoords);
      else this.map.setView(this.userCoords, 17);
    },
    confirmLocation() {
      // if (!this.checkMobileNumber()) return;
      var coords = this.marker.getLatLng();
      var loader = this.loadingDots();
      this.$store
        .dispatch("reverseGeocode", coords)
        .then((res) => {
          this.console("reverseGeocode", res);
          this.streetName = res.data.address.road;
          if (this.addressName === "") this.locationInput = this.streetName;
          // this.emitLocation(coords);
        })
        .catch((err) => console.error("reverseGeocode error", err))
        .finally(() => {
          loader.hide();
          this.emitLocation(coords); // moved here since it should emit even if err
        });
    },
    emitLocation(coords) {
      if (!this.streetName) this.streetName = this.googleStreetName;
      if (!this.streetName) this.streetName = "Pin Location";
      return this.reallyEmit(coords);
    },
    reallyEmit(coords, addressName) {
      console.log("reallyEmit", this.callback, addressName, coords);
      //   if (!addressName) addressName = this.addressName;
      var locationData = {
        name: this.parseStopName(addressName),
        address: this.fullAddress,
        lat: coords.lat,
        lon: coords.lng,
      };
      this.$emit("submit", locationData);
    },
    parseStopName(addressName) {
      if (!addressName) return this.streetName;
      if (!this.streetName) return addressName;
      return `${this.streetName}, ${addressName}`;
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  left: 0;
  width: 100vw;
  height: calc(100vh - 210px);
  overflow: hidden;
}
.field {
  margin: 0;
  margin-top: 8px;
}
.input {
  border-radius: 0;
}
.map-wrapper {
  position: relative;
  height: calc(100% - 50px);
  width: 100%;
  z-index: 0;
  overflow: hidden;
  box-shadow: 0 0 1px rgb(172, 172, 172);
}
.map {
  position: relative;
  height: 100%;
  width: 100%;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.7);
  margin: -3px 0;
}
input::-webkit-input-placeholder {
  /* color: #2693da !important; */
  opacity: 0.8;
}
.recenter-btn {
  margin: 10px;
  padding: 0 9px;
  pointer-events: auto;
}
.confirm-wrapper {
  margin: 10px;
  margin-top: -60px;
}
.confirm-wrapper .button {
  box-shadow: 0 0 3px white, 0 0 5px white;
}
</style>

<style lang="scss">
#shop-create-map-map {
  .leaflet-control-locate {
    border-radius: 50%;
  }
  .leaflet-control-locate a {
    border-radius: 50%;
  }
  .leaflet-popup-content {
    padding: 5px 5px;
    margin: 1px 0;
    // color: rgb(23, 23, 193);
    color: rgb(23, 102, 193);
    font-size: 1.2em;
    // max-width: 130px;
  }
  .leaflet-popup-content i {
    font-weight: 500;
    opacity: 0.8;
    // color: grey;
  }
  .blue-dot {
    margin-left: 0px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background-color: #2693da;
    opacity: 0.9;
    border: 1px solid #feeaa4b5;
  }
  .pulse {
    // animation: shadow-pulse 2s infinite;
    animation: pulsate 3s ease-out infinite;
  }
  @keyframes pulsate {
    0% {
      box-shadow: 0 0 0 1px cyan;
    }
    50% {
      box-shadow: 0 0 0 6px rgba(255, 217, 0, 0.5);
    }
    100% {
      box-shadow: 0 0 0 1px lightskyblue;
    }
  }
  @-webkit-keyframes pulsate {
    0% {
      box-shadow: 0 0 0 1px cyan;
    }
    50% {
      box-shadow: 0 0 0 6px rgba(255, 217, 0, 0.5);
    }
    100% {
      box-shadow: 0 0 0 1px lightskyblue;
    }
  }
}
</style>